import { Helmet } from "react-helmet";
import Header from "../../../Components/Header";
import BomForm from "./BomForm";

const CreateBom = () => {
  return (
    <div className='d-flex flex-column' style={{ minHeight: '100vh' }}>
      <Helmet>
				<title>BOM - Create</title>
			</Helmet>
      <Header />
      <div className="container-fluid maindiv d-flex flex-column" style={{flexGrow:'1'}}>
        <BomForm />
      </div>
    </div>
  );
};

export default CreateBom;
